import { get } from "@ember/object"

export function initialize(appInstance) {
  let session = appInstance.lookup("service:session")
  appInstance.lookup("service:app-state")
  let patchCoordinator = appInstance.lookup("service:patch-coordinator")
  patchCoordinator.applyLocalPatch({
    document: {
      id: get(session, "id"),
      modelType: "app-state",
      ops: {},
    },
    isCreatePatch: true,
  })
}

export default {
  name: "app-state",
  initialize: initialize,
  after: ["session"],
}
